function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#adc6ca",
  d: "M19.5 13H15v-1h2c1.331 0 2.006-1.616 1.06-2.56l-5-5a1.5 1.5 0 00-2.123 0l-5 5C4.998 10.38 5.667 12 7 12h2v1H4.5A1.5 1.5 0 003 14.5v4A1.5 1.5 0 004.5 20h15a1.5 1.5 0 001.5-1.5v-4a1.5 1.5 0 00-1.5-1.5zM7 10.5l5-5.001 5 5h-3.5v5h-3v-5H7zm12.5 8h-15v-4H9v1a1.5 1.5 0 001.5 1.5h3a1.5 1.5 0 001.5-1.5v-1h4.5v4zm-1.25-2c0 .415-.334.75-.75.75s-.75-.335-.75-.75c0-.416.334-.75.75-.75s.75.334.75.75z"
});

function SvgUploadinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgUploadinline;